"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _createMixin = _interopRequireDefault(require("../utils/createMixin"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable max-len */
var _default = (0, _createMixin["default"])(function (theme, _ref) {
  var width = _ref.width,
    style = _ref.style,
    colors = _ref.colors,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? '' : _ref$position,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
  var outerBorderColor = colors && colors.outerBorderColor;
  if (!width || !style || !outerBorderColor) {
    console.error('Please provide a width, style and outerBorderColor value when using the borderGenerator mixin');
    return (0, _styledComponents.css)([""]);
  }
  if (prefix) {
    return (0, _styledComponents.css)(["", "{", " ", "}"], prefix, position && "\n          border".concat("-".concat(position), ": ", width, " ").concat(style, " ").concat(outerBorderColor, ";\n        "), !position && "\n          border: ".concat(width, " ").concat(style, " ").concat(outerBorderColor, ";\n        "));
  }
  return (0, _styledComponents.css)(["", " ", ""], position && "\n      border".concat("-".concat(position), ": ", width, " ").concat(style, " ").concat(outerBorderColor, ";\n    "), !position && "\n      border: ".concat(width, " ").concat(style, " ").concat(outerBorderColor, ";\n    "));
});
exports["default"] = _default;